import _Promise from '/app/node_modules/babel-runtime/core-js/promise';
import Vue from 'vue';
import Router from 'vue-router';

Vue.use(Router);

var _2b8b9438 = function _2b8b9438() {
	return import('../src/pages/commisionPreviewer.vue' /* webpackChunkName: "pages/commisionPreviewer" */).then(function (m) {
		return m.default || m;
	});
};
var _033abec8 = function _033abec8() {
	return import('../src/pages/tariff/index.vue' /* webpackChunkName: "pages/tariff/index" */).then(function (m) {
		return m.default || m;
	});
};
var _61aec61c = function _61aec61c() {
	return import('../src/pages/buttons.vue' /* webpackChunkName: "pages/buttons" */).then(function (m) {
		return m.default || m;
	});
};
var _8849ed4c = function _8849ed4c() {
	return import('../src/pages/reports.vue' /* webpackChunkName: "pages/reports" */).then(function (m) {
		return m.default || m;
	});
};
var _e889b8c0 = function _e889b8c0() {
	return import('../src/pages/forgot-password.vue' /* webpackChunkName: "pages/forgot-password" */).then(function (m) {
		return m.default || m;
	});
};
var _3f606885 = function _3f606885() {
	return import('../src/pages/load-ad.vue' /* webpackChunkName: "pages/load-ad" */).then(function (m) {
		return m.default || m;
	});
};
var _57cd8778 = function _57cd8778() {
	return import('../src/pages/profile.vue' /* webpackChunkName: "pages/profile" */).then(function (m) {
		return m.default || m;
	});
};
var _71ef60da = function _71ef60da() {
	return import('../src/pages/bosses/index.vue' /* webpackChunkName: "pages/bosses/index" */).then(function (m) {
		return m.default || m;
	});
};
var _2c7dcb26 = function _2c7dcb26() {
	return import('../src/pages/affiliation-terms-and-conditions.vue' /* webpackChunkName: "pages/affiliation-terms-and-conditions" */).then(function (m) {
		return m.default || m;
	});
};
var _0e5d8a19 = function _0e5d8a19() {
	return import('../src/pages/personal-data-protection-law.vue' /* webpackChunkName: "pages/personal-data-protection-law" */).then(function (m) {
		return m.default || m;
	});
};
var _95920c88 = function _95920c88() {
	return import('../src/pages/my-team/index.vue' /* webpackChunkName: "pages/my-team/index" */).then(function (m) {
		return m.default || m;
	});
};
var _49a1776f = function _49a1776f() {
	return import('../src/pages/restore-password.vue' /* webpackChunkName: "pages/restore-password" */).then(function (m) {
		return m.default || m;
	});
};
var _5185ddfa = function _5185ddfa() {
	return import('../src/pages/affiliation-detail.vue' /* webpackChunkName: "pages/affiliation-detail" */).then(function (m) {
		return m.default || m;
	});
};
var _0c6b1b9c = function _0c6b1b9c() {
	return import('../src/pages/dashboard/index.vue' /* webpackChunkName: "pages/dashboard/index" */).then(function (m) {
		return m.default || m;
	});
};
var _3a65b67d = function _3a65b67d() {
	return import('../src/pages/ranking-detail.vue' /* webpackChunkName: "pages/ranking-detail" */).then(function (m) {
		return m.default || m;
	});
};
var _4e820108 = function _4e820108() {
	return import('../src/pages/channels/index.vue' /* webpackChunkName: "pages/channels/index" */).then(function (m) {
		return m.default || m;
	});
};
var _595b70de = function _595b70de() {
	return import('../src/pages/new-affiliation.vue' /* webpackChunkName: "pages/new-affiliation" */).then(function (m) {
		return m.default || m;
	});
};
var _5646aea2 = function _5646aea2() {
	return import('../src/pages/bosses/channel/_id.vue' /* webpackChunkName: "pages/bosses/channel/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _13edaff2 = function _13edaff2() {
	return import('../src/pages/bosses/channel/_id/index.vue' /* webpackChunkName: "pages/bosses/channel/_id/index" */).then(function (m) {
		return m.default || m;
	});
};
var _8346655c = function _8346655c() {
	return import('../src/pages/bosses/channel/_id/seller/index.vue' /* webpackChunkName: "pages/bosses/channel/_id/seller/index" */).then(function (m) {
		return m.default || m;
	});
};
var _562fe24e = function _562fe24e() {
	return import('../src/pages/bosses/channel/_id/seller/_idSeller.vue' /* webpackChunkName: "pages/bosses/channel/_id/seller/_idSeller" */).then(function (m) {
		return m.default || m;
	});
};
var _b2a3da2e = function _b2a3da2e() {
	return import('../src/pages/my-team/sellers/_id.vue' /* webpackChunkName: "pages/my-team/sellers/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _511770d2 = function _511770d2() {
	return import('../src/pages/channels/teams/_id.vue' /* webpackChunkName: "pages/channels/teams/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _db06fe4c = function _db06fe4c() {
	return import('../src/pages/channels/teams/_id/index.vue' /* webpackChunkName: "pages/channels/teams/_id/index" */).then(function (m) {
		return m.default || m;
	});
};
var _40c81f34 = function _40c81f34() {
	return import('../src/pages/channels/teams/_id/sellers/_idSeller.vue' /* webpackChunkName: "pages/channels/teams/_id/sellers/_idSeller" */).then(function (m) {
		return m.default || m;
	});
};
var _5d594dcc = function _5d594dcc() {
	return import('../src/pages/dashboard/_id.vue' /* webpackChunkName: "pages/dashboard/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _74181a04 = function _74181a04() {
	return import('../src/pages/tariff/_id.vue' /* webpackChunkName: "pages/tariff/_id" */).then(function (m) {
		return m.default || m;
	});
};
var _27eb63ad = function _27eb63ad() {
	return import('../src/pages/index.vue' /* webpackChunkName: "pages/index" */).then(function (m) {
		return m.default || m;
	});
};

if (process.client) {
	window.history.scrollRestoration = 'manual';
}
var scrollBehavior = function scrollBehavior(to, from, savedPosition) {
	// if the returned position is falsy or an empty object,
	// will retain current scroll position.
	var position = false;

	// if no children detected
	if (to.matched.length < 2) {
		// scroll to the top of the page
		position = { x: 0, y: 0 };
	} else if (to.matched.some(function (r) {
		return r.components.default.options.scrollToTop;
	})) {
		// if one of the children has scrollToTop option set to true
		position = { x: 0, y: 0 };
	}

	// savedPosition is only available for popstate navigations (back button)
	if (savedPosition) {
		position = savedPosition;
	}

	return new _Promise(function (resolve) {
		// wait for the out transition to complete (if necessary)
		window.$nuxt.$once('triggerScroll', function () {
			// coords will be used if no selector is provided,
			// or if the selector didn't match any element.
			if (to.hash) {
				var hash = to.hash;
				// CSS.escape() is not supported with IE and Edge.
				if (typeof window.CSS !== 'undefined' && typeof window.CSS.escape !== 'undefined') {
					hash = '#' + window.CSS.escape(hash.substr(1));
				}
				try {
					if (document.querySelector(hash)) {
						// scroll to anchor by returning the selector
						position = { selector: hash };
					}
				} catch (e) {
					console.warn('Failed to save scroll position. Please add CSS.escape() polyfill (https://github.com/mathiasbynens/CSS.escape).');
				}
			}
			resolve(position);
		});
	});
};

export function createRouter() {
	return new Router({
		mode: 'history',
		base: '/',
		linkActiveClass: 'nuxt-link-active',
		linkExactActiveClass: 'nuxt-link-exact-active',
		scrollBehavior: scrollBehavior,
		routes: [{
			path: "/commisionPreviewer",
			component: _2b8b9438,
			name: "commisionPreviewer"
		}, {
			path: "/tariff",
			component: _033abec8,
			name: "tariff"
		}, {
			path: "/buttons",
			component: _61aec61c,
			name: "buttons"
		}, {
			path: "/reports",
			component: _8849ed4c,
			name: "reports"
		}, {
			path: "/forgot-password",
			component: _e889b8c0,
			name: "forgot-password"
		}, {
			path: "/load-ad",
			component: _3f606885,
			name: "load-ad"
		}, {
			path: "/profile",
			component: _57cd8778,
			name: "profile"
		}, {
			path: "/bosses",
			component: _71ef60da,
			name: "bosses"
		}, {
			path: "/affiliation-terms-and-conditions",
			component: _2c7dcb26,
			name: "affiliation-terms-and-conditions"
		}, {
			path: "/personal-data-protection-law",
			component: _0e5d8a19,
			name: "personal-data-protection-law"
		}, {
			path: "/my-team",
			component: _95920c88,
			name: "my-team"
		}, {
			path: "/restore-password",
			component: _49a1776f,
			name: "restore-password"
		}, {
			path: "/affiliation-detail",
			component: _5185ddfa,
			name: "affiliation-detail"
		}, {
			path: "/dashboard",
			component: _0c6b1b9c,
			name: "dashboard"
		}, {
			path: "/ranking-detail",
			component: _3a65b67d,
			name: "ranking-detail"
		}, {
			path: "/channels",
			component: _4e820108,
			name: "channels"
		}, {
			path: "/new-affiliation",
			component: _595b70de,
			name: "new-affiliation"
		}, {
			path: "/bosses/channel/:id?",
			component: _5646aea2,
			children: [{
				path: "",
				component: _13edaff2,
				name: "bosses-channel-id"
			}, {
				path: "seller",
				component: _8346655c,
				name: "bosses-channel-id-seller"
			}, {
				path: "seller/:idSeller",
				component: _562fe24e,
				name: "bosses-channel-id-seller-idSeller"
			}]
		}, {
			path: "/my-team/sellers/:id",
			component: _b2a3da2e,
			name: "my-team-sellers-id"
		}, {
			path: "/channels/teams/:id?",
			component: _511770d2,
			children: [{
				path: "",
				component: _db06fe4c,
				name: "channels-teams-id"
			}, {
				path: "sellers/:idSeller?",
				component: _40c81f34,
				name: "channels-teams-id-sellers-idSeller"
			}]
		}, {
			path: "/dashboard/:id",
			component: _5d594dcc,
			name: "dashboard-id"
		}, {
			path: "/tariff/:id",
			component: _74181a04,
			name: "tariff-id"
		}, {
			path: "/",
			component: _27eb63ad,
			name: "index"
		}],

		fallback: false
	});
}


//////////////////
// WEBPACK FOOTER
// ./.nuxt/router.js
// module id = ./.nuxt/router.js
// module chunks = 34